<template>
    <div>
        <j-table
            :loading="loading"
            :tableColumns="columns"
            :tableData="tableData"
            :rowKey="record => record.id"
            :tablePagination="pagination"
            v-on:onOrderbyChange="(newOrderby)=>{ orderby = newOrderby;fetch(); }"
            v-on:onPaginationChange="(newPagination)=>{ pagination = newPagination;fetch(); }">
        </j-table>
    </div>
</template>
<script>
import JTable from "../../components/JTable"
const columns = [
    {title:'账户名称',dataIndex:'accountname',key:'accountname',align:'center',fixed:'left'},
    {title:'账户号',dataIndex:'bkaccount',key:'bkaccount',align:'center',width:200},
    {title:'合同编号',dataIndex:'contno',key:'contno',align:'center'},
    {title:'手机号',dataIndex:'mobile',key:'mobile',align:'center'},
    {
        title:'订单金额',
        dataIndex:'order_amt',
        key:'order_amt',
        align:'center',
        customRender: function(text) {
            if (!text) return "0.00";
            return parseFloat(text / 100).toFixed(2);
        }
    },
    {title:'订单状态',dataIndex:'order_status',key:'order_status',align:'center',customRender:function(text){return text == '00' ? '待审核': text == '01' ? '未支付' : text == '02' ? '支付中' : text == '03' ? '支付完成' : text == '04' ? '支付失败' : text} },
    {title:'订单类型',dataIndex:'order_type',key:'order_type',align:'center',customRender:function(text){return text == '00' ? '提现' : text == '01' ? '退款' : text} },
    {title:'支付类型',dataIndex:'paytype',key:'paytype',align:'center',customRender:function(text){return text == '00' ? '银行转账' : text }},
    {title:'记录编号',dataIndex:'recid',key:'recid',align:'center',width:200},
    {title:'银行日期',dataIndex:'bkdate',key:'bkdate',align:'center'},
    {title:'银行返回码',dataIndex:'bkresp',key:'bkresp',align:'center'},
    {title:'银行返回描述',dataIndex:'bkrespdesc',key:'bkrespdesc',align:'center'},
    {title:'银行流水号',dataIndex:'bkssn',key:'bkssn',align:'center',width:200},
    {title:'中心日期',dataIndex:'cen_date',key:'cen_date',align:'center'},
    {title:'中心时间',dataIndex:'cen_time',key:'cen_time',align:'center'},
    {title:'创建时间',dataIndex:'rec_crt_time',key:'rec_crt_time',align:'center'},
    {title:'修改时间',dataIndex:'rec_upt_time',key:'rec_upt_time',align:'center'},
    {title:'请求日期',dataIndex:'req_date',key:'req_date',align:'center'},
    {title:'请求流水号',dataIndex:'req_seq',key:'req_seq',align:'center',width:200},
    {title:'请求时间',dataIndex:'req_time',key:'req_time',align:'center'},
    {title:'平台日期',dataIndex:'sett_date',key:'sett_date',align:'center'},
]
export default {
    name: 'OrderInfor',
    components:{
        JTable,
    },
    data(){
        return{
            drivasstid:this.$cache.session.get(this.$marco.constants.KEY_ORG_ID),
            loading:false,
            columns,
            tableData:[],
            pagination:{
                current:1,
                total:0,
                pageSize:10,
                pageSizeOptions:['1','10','20','50']
            },
            orderby:'drivasstid desc'
        }
    },
    created(){
        this.fetch();
    },
    methods:{
        fetch(){
            const that = this;
            const reqData = {
                drivasstid:that.drivasstid,
                currpage: that.pagination.current,
                // drivschid: 1,
                orderby: that.orderby,
                // recid: 11111,
                recnumperpage: that.pagination.pageSize,
            };
            that.tableData = [];
            that.$http.post(
                that.$marco.api.orderlist,
                reqData,
                data => {
                    this.$log.success(JSON.stringify(data));
                    that.tableData = that.tableData.concat(data.pagelist);
                    that.pagination.total = data.recnum
                },
                errorDesc => {
                    this.$log.normal(JSON.stringify(errorDesc));
                },
                error => {
                    this.$log.error(JSON.stringify(error));
                },
                that
            );
        }
    }
}
</script>
<style>
</style>